/* src/app/shared/components/layout/network-status-info/network-status-info.component.scss */
.navbar-info-message {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  color: #fff;
  font-size: 0.875rem;
  z-index: 1;
}
.navbar-info-message__height {
  height: 30px;
}
/*# sourceMappingURL=network-status-info.component.css.map */
